<div class="container-fluid" data-id-cypress="my-dashboard">
  <jhi-alert></jhi-alert>
  <jhi-bary-light-estimate></jhi-bary-light-estimate>
  <div class="mt-3">
    <jhi-charts-stats
      *ngIf="customerId"
      [id]="customerId"
      [buttons]="buttons"
      titleKey="dashboard.stats.title"
      table="CUSTOMER"
      [billDate]="true"
      [maskOptions]="true"
    ></jhi-charts-stats>
  </div>
  <div class="row mt-3">
    <div class="col-12 col-xl-6 mb-3">
      <jhi-bary-card titleKey="dashboard.transports.title">
        <div body>
          <table mdbTable [borderless]="true" class="table-responsive-sm text-center">
            <tr *ngFor="let transportOrder of transportOrders">
              <td jhiTranslate="TRANSPORT_ORDER.ID" [translateValues]="{ transportOrderId: transportOrder.id }"></td>
              <td>
                {{ transportOrder.pickupDate!.toDate() | date: 'shortDate' }}
              </td>
              <td>
                {{ (transportOrder.pickupAddressCity ? transportOrder.pickupAddressCity : '') | capitalize }}
                -{{ (transportOrder.deliveryAddressCity ? transportOrder.deliveryAddressCity : '') | capitalize }}
              </td>
              <td>{{ transportOrder.totalPallets }} {{ ((transportOrder.totalPallets || 0) > 1 ? 'PALLETS' : 'PALLET') | translate }}</td>
              <td>
                <jhi-bary-badge [options]="transportOrder.statusBadgeOpts()"></jhi-bary-badge>
              </td>
              <hr />
            </tr>
          </table>
          <button
            type="button"
            class="btn btn-primary btn-rounded mt-3 d-block w-md-50 mx-auto"
            [routerLink]="[PATHS.USER_MY_TRANSPORTS.path]"
            jhiTranslate="BTN.SEE_ALL_MY_TRANSPORTS"
          ></button>
        </div>
      </jhi-bary-card>
    </div>
    <div class="col-12 col-xl-6 mb-3">
      <jhi-bary-card titleKey="dashboard.bills.title">
        <div body>
          <table mdbTable [borderless]="true" class="table-responsive-sm text-center">
            <tr *ngFor="let bill of bills">
              <td class="align-middle pl-0">
                {{ bill.billDate!.toDate() | date: 'shortDate' }}
              </td>
              <td class="align-middle px-0">
                {{ bill.priceHt | currency: 'EUR' }}
              </td>
              <td class="align-middle" *ngIf="isPaymentMethod(bill.paymentMethod)">
                {{ bill.paymentMethod.translationKey! | translate }}
              </td>
              <td class="align-middle px-0 text-left">
                <jhi-bary-badge [options]="bill.statusBadgeOpts()"></jhi-bary-badge>
              </td>
              <td class="align-middle text-center pr-0">
                <jhi-bary-button
                  [tooltip]="'BTN.DISPLAY' | translate"
                  (clickEvent)="browserPdf(bill.id!)"
                  icon="eye"
                  class="m-1"
                  [floating]="true"
                  [rounded]="true"
                  size="sm"
                  color="info"
                >
                </jhi-bary-button>
                <jhi-bary-button
                  [tooltip]="'BTN.DOWNLOAD' | translate"
                  (clickEvent)="download(bill.id!)"
                  icon="file-download"
                  [floating]="true"
                  [rounded]="true"
                  size="sm"
                  color="info"
                >
                </jhi-bary-button>
              </td>
              <hr />
            </tr>
          </table>
          <button
            type="button"
            class="btn btn-primary btn-rounded mt-3 d-block w-md-50 mx-auto"
            [routerLink]="[PATHS.USER_MY_BILLS.path]"
            jhiTranslate="BTN.SEE_ALL_MY_BILLS"
          ></button>
        </div>
      </jhi-bary-card>
    </div>
  </div>
</div>
